<template>
  <div class="content-card  pa3 pt2 tl">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'primary-button',
  data() {
    return {
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ContentCard.vue?692c4c30